// Runs in both getStaticProps (Node) and the browser, so entities are decoded
// with a map/regex instead of DOM APIs. Unknown named entities are left as-is.
const NAMED_ENTITY_MAP: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  ndash: '–',
  mdash: '—',
  hellip: '…',
  lsquo: '‘',
  rsquo: '’',
  ldquo: '“',
  rdquo: '”',
  aelig: 'æ',
  AElig: 'Æ',
  oslash: 'ø',
  Oslash: 'Ø',
  aring: 'å',
  Aring: 'Å',
  times: '×',
  divide: '÷',
  minus: '−',
  plusmn: '±',
  middot: '·',
  sdot: '⋅',
  deg: '°',
  le: '≤',
  ge: '≥',
  ne: '≠',
  pi: 'π',
  infin: '∞',
  radic: '√',
  sup2: '²',
  sup3: '³',
  frac12: '½',
  frac14: '¼',
  frac34: '¾',
}

const MAX_CODE_POINT = 0x10ffff

const decodeHtmlEntity = (entity: string, hexCode = '', decimalCode = '', name = ''): string => {
  if (hexCode || decimalCode) {
    const codePoint = hexCode ? parseInt(hexCode, 16) : parseInt(decimalCode, 10)
    return codePoint <= MAX_CODE_POINT ? String.fromCodePoint(codePoint) : entity
  }
  return NAMED_ENTITY_MAP[name] ?? entity
}

export const htmlToPlainText = (html?: string | null): string => {
  if (!html) {
    return ''
  }

  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&(?:#x([0-9a-f]+)|#(\d+)|(\w+));/gi, decodeHtmlEntity)
    .replace(/\s+/g, ' ')
}
